import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const useContacts = (page = 1, limit = 10, search = "") => {
    const queryClient = useQueryClient();

    const contactQuery = useQuery({
        queryKey: ["contacts", page, limit, search],
        queryFn: async () => {
            const response = await apiClient.get(`/contact?page=${page}&limit=${limit}&search=${search}`);
            return response?.data || {};
        },
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => apiClient.delete(`/contact/${id}`),
        onSuccess: () => {
            toast.success("Contact message deleted!");
            queryClient.invalidateQueries({ queryKey: ["contacts"] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || "Failed to delete message");
        }
    });

    return {
        contacts: contactQuery.data?.data?.data || [],
        pagination: contactQuery.data?.data?.pagination || null,
        isLoading: contactQuery.isLoading,
        deleteContact: deleteMutation.mutateAsync,
        isDeleting: deleteMutation.isPending,
    };
};